<template>
  <ul class="mt-2">
    <li v-for="value in refObj" :key = "value.law_id">
      <p  style="width:100%;">
        <router-link :to="`/law_res/detail/${value.law_id}`" :title="value.law_title">{{ value.law_title }}</router-link>
      <span>{{ moment(created).format("YYYY-MM-DD") }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import base from '@/core/base.js'
export default {
  name: 'Law',
  mixins: [base]
}
</script>
